'use strict';
const mmWidgets = require('./mm-widgets');
require('./section-handler-widget');
require('./show-progress-message');
require('./display-error');
mmWidgets.fn.cognitoChangePasswordWidget = function (cognitoApi, cognitoAuthenticator, authenticationModel) {
	return mmWidgets.each(this, function () {
		const widget = this,
			isIntitalSection = widget.attr('data-mm-initial-section') === 'cognito-change-password',
			section = widget.find('[data-mm-section~="cognito-change-password"]'),
			changePasswordInitButton = widget.find('[data-mm-role~="cognito-can-change-password"]'),
			changePasswordButton = widget.find('[data-mm-role~="cognito-change-password"]'),
			oldPasswordField = widget.find('[name="cognito-old-password"]'),
			newPasswordField = widget.find('[name="cognito-new-password"]'),
			newPasswordRetypeField = widget.find('[name="cognito-new-password-retype"]'),
			cleanup = function () {
				section.displayError();
				oldPasswordField.val('');
				newPasswordField.val('');
				newPasswordRetypeField.val('');
				widget.trigger('cleanupComplete');
			},
			checkForCanChangePassword = function () {
				cognitoAuthenticator.getProfile().then(function (cognitoProfile) {
					if (cognitoProfile) {
						changePasswordInitButton.removeClass('hidden');
					} else {
						changePasswordInitButton.addClass('hidden');
					}
					widget.trigger('checkedForCanChangePassword');
				}, function () {
					changePasswordInitButton.addClass('hidden');
					widget.trigger('checkedForCanChangePassword');
				});
			};

		widget.on('show', function () {
			checkForCanChangePassword();
			cleanup();
			if (isIntitalSection) {
				widget.showSection('cognito-change-password');
			}
		});
		widget.on('hide', function () {
			cleanup();
		});
		if (isIntitalSection) {
			widget.sectionHandlerWidget();
		}
		changePasswordButton.click(function () {
			const oldPassword = oldPasswordField.val(),
				newPassword = newPasswordField.val(),
				newPasswordRetype = newPasswordRetypeField.val();
			let hasErrors = false;

			section.displayError();
			if (!oldPassword) {
				section.displayError('cognito-no-old-password');
				hasErrors = true;
			}
			if (!newPassword) {
				section.displayError('cognito-no-new-password', hasErrors);
				hasErrors = true;
			}
			if (oldPassword && oldPassword === newPassword) {
				section.displayError('cognito-same-new-password', hasErrors);
				hasErrors = true;
			}
			if (newPassword !== newPasswordRetype) {
				section.displayError('cognito-password-retype-mismatch', hasErrors);
				hasErrors = true;
			}
			if (hasErrors) {
				widget.trigger('changePasswordButtonClickError');
				return;
			}
			widget.showProgressMessage('Changing password, please wait...');
			cognitoApi.changePassword(oldPassword, newPassword).then(function () {
				if (isIntitalSection) {
					widget.showSection('cognito-change-password-success');
				} else {
					widget.trigger('show');
				}
			}, function (err) {
				widget.showSection('cognito-change-password');
				section.displayError(err || 'cognito-change-password-failed');
				widget.trigger('changePasswordButtonClickError');
			});
		});
		authenticationModel.addEventListener('authenticatedProfile', checkForCanChangePassword);
		authenticationModel.addEventListener('not-authenticated', function () {
			changePasswordInitButton.addClass('hidden');
		});
	});

};

